import { render } from "./SectionHeader.vue?vue&type=template&id=7f7a147a"
import script from "./SectionHeader.vue?vue&type=script&lang=js"
export * from "./SectionHeader.vue?vue&type=script&lang=js"
script.render = render

export default script